<template>
    <bs5-base-modal title="Edit Client" :visible="visible" @close="closeModal">
        <template v-slot:default>
            <form @submit.prevent="updateClient">
                <div class="mb-3">
                    <bs5-base-label for="name">Name</bs5-base-label>
                    <bs5-base-input id="name" v-model="client.name" required />
                </div>

                <div class="mb-3">
                    <bs5-base-label for="description">Description</bs5-base-label>
                    <bs5-base-input id="description" v-model="client.description" />
                </div>
            </form>
        </template>

        <template v-slot:footer>
            <bs5-cancel-button @click="closeModal" />
            <bs5-save-button :loading="saving" @click="updateClient">Save Changes</bs5-save-button>
        </template>
    </bs5-base-modal>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import clientService from "@/services/client.service";
import { Client } from "@/models/client.model";
import { showToast } from "@/utils/toast";

export default defineComponent({
    name: "EditClientModal",
    props: {
        visible: { type: Boolean, required: true },
        clientId: { type: String, required: true },
    },
    emits: ["close", "client-updated"],
    data() {
        return {
            client: ref<Client>({ id: "", name: "", description: "", distributorId: "" }),
            saving: ref(false),
        };
    },
    watch: {
        clientId: {
            immediate: true,
            handler(newId) {
                console.log("watch", newId);
                if (newId) this.fetchClient();
            },
        },
    },
    methods: {
        async fetchClient() {
            try {
                this.client = await clientService.getClientById(this.clientId);
            } catch (error) {
                console.error("Error fetching client:", error);
            }
        },
        async updateClient() {
            this.saving = true;
            try {
                await clientService.updateClient(this.client.id as string, {...this.client});
                this.$emit("client-updated");
                this.closeModal();
                showToast("Client updated!", "success")
            } catch (error) {
                showToast("Failed to update client!", "error")
            } finally {
                this.saving = false;
            }
        },
        closeModal() {
            this.$emit("close");
        },
    },
});
</script>